

import { Button, Card, Collapse, IconButton, List, ListItemButton, ListItemIcon, ListItemText, TextField, Tooltip, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'
// import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../../services/api';
import Loading from '../../../../load/loading';
import LoadingShort from '../../../../load/loadingShort';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import compressImage from '../../../../services/compressImage';
import CloseIcon from '@mui/icons-material/Close';
import Date from '../../../../utils/date';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Avatar } from '@material-ui/core';
import AvaliacaoAnalitica from './avaliacaoAnalitica';
import DocumentosEmitidos from './documentosEmitidos';


export default function AnaliseProduto({ solicitacaoAnalise, avaliacaoAnalitica, setAvaliacaoAnalitica }) {
    const user = useSelector(state => state.account.user);
    const { id } = useParams()
    const { produtoId } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false)
    const [loadAddImage, setLoadAddImage] = useState(false)
    const [produto, setProduto] = useState('')
    const [imageDissolucao, setImageDissolucao] = useState([]);
    const [imageTesteVisual, setImageTesteVisual] = useState([]);
    const [imageTesteCromato, setImageTesteCromato] = useState([]);
    const [imageTestePH, setImageTestePH] = useState([]);
    const [quantidadeAmostras, setQuantidadeAmostras] = useState('')
    const [openImagensCapturadas, setOpenImagensCapturadas] = useState(false);
    const [refresh, setRefresh] = useState('');

    useEffect(() => {
        api.get(`/producto/${produtoId}`)
            .then(response => {
                // console.log(response)
                setProduto(response.data.producto);
            }).catch(err => { });
    }, [id, setProduto, refresh])

    useEffect(() => {
        if (Array.isArray(avaliacaoAnalitica?.testesDissolucao)) {
            avaliacaoAnalitica.testesDissolucao.forEach((teste) => {
                if (teste?.imagens?.length) {
                    api.post('/get-imagebase64', { urls: teste.imagens })
                        .then(res => {
                            // setImageDissolucao((prev) => [...prev, ...res.data.images]);
                            setImageDissolucao((prev) => Array.from(new Set([...prev, ...res.data.images])));
                        })
                        .catch(err => 'console.log(err)');
                }
            });
        }
        if (Array.isArray(avaliacaoAnalitica?.cromatografia)) {
            const todasImagens = avaliacaoAnalitica.cromatografia
                .flatMap(teste => teste?.imagens?.length ? teste.imagens : []);

            if (todasImagens.length) {
                api.post('/get-imagebase64', { urls: todasImagens })
                    .then(res => setImageTesteCromato((prev) => Array.from(new Set([...prev, ...res.data.images]))))
                    .catch(err => 'console.log(err)');
            }
        }

        if (Array.isArray(avaliacaoAnalitica?.inspeccaoVisualFisica)) {
            const todasImagens = avaliacaoAnalitica.inspeccaoVisualFisica
                .flatMap(teste => teste?.imagens?.length ? teste.imagens : []);

            if (todasImagens.length) {
                api.post('/get-imagebase64', { urls: todasImagens })
                    .then(res => setImageTesteVisual((prev) => Array.from(new Set([...prev, ...res.data.images]))))
                    .catch(err => 'console.log(err)');
            }
        }

        if (Array.isArray(avaliacaoAnalitica?.testesPH)) {
            const todasImagens = avaliacaoAnalitica.testesPH
                .flatMap(teste => teste?.imagens?.length ? teste.imagens : []);

            if (todasImagens.length) {
                api.post('/get-imagebase64', { urls: todasImagens })
                    .then(res => setImageTestePH((prev) => Array.from(new Set([...prev, ...res.data.images]))))
                    .catch(err => 'console.log(err)');
            }
        }

    }, [avaliacaoAnalitica])

    const handleQuatidadeAmostas = () => {
        setLoad(true)
        api.patch('/producto/edit-quantidade-amostras', {
            // status: status,
            productoId: produto._id,
            quatidadeAmostras: quantidadeAmostras,
            quantidadeAmostras,
            userId: user?._id
        }).then(response => {
            setProduto(response.data.producto)
            dispatch({
                type: 'alert',
                payload: { alert: 'Quantidade de amostra inserido com sucesso.!' },
            });
            // console.log(response)
        }).catch(error => {
            // console.log(error)
            setMessageError(error.response.data.message)
        }).finally(() => setLoad(false))
    }

    async function postImage(e) {
        setLoadAddImage(true)
        let imageComprimida = await compressImage(e.target.files[0])

        const formData = new FormData();
        formData.append('imagem', imageComprimida);
        formData.append('productoId', produto?._id);
        formData.append('userId', user?._id);

        await api.patch(`/producto/add-image`, formData)
            .then(response => {
                setProduto(response.data.producto);
                setLoadAddImage(false)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Amostra adicionada.!' },
                });

            }).catch(err => {
                setLoadAddImage(false)
            })
    }

    const CaptureImage = () => {
        return (
            <>
                <IconButton size='large'  >
                    {loadAddImage ? <LoadingShort />
                        :
                        <label htmlFor="capitureImage" >
                            <Tooltip title="Carregar imagens da amostra">
                                <CameraAltIcon />
                            </Tooltip>
                        </label>
                    }
                </IconButton>
                <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="capitureImage" style={{ display: 'none' }} onChange={postImage} />
            </>
        )
    }
    // console.log(avaliacaoAnalitica)

    return (
        produto ?
            <>
                <Card style={{ padding: 20, position: 'relative' }}>

                    <IconButton title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => { navigate(`/admin/dcqmts/gest/solicitacao-de-analise/${solicitacaoAnalise?._id}`) }}> <CloseIcon /></IconButton>

                    {/* {messageSuccess && <MessageSuccess message={messageSuccess} />} */}
                    {messageError && <MessageError message={messageError} />}

                    <HeaderGestorConfigs
                        menu={false}
                        configArea={''}
                        title={'PRODUTO'}
                    />

                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Estado:</strong> {produto?.status ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Nome:</strong> {produto?.nome ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Forma Farmaceutica:</strong> {produto?.formaFarmaceutica ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Tipo:</strong> {produto?.tipo ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Dosagem:</strong> {produto?.dosagemConcentracao ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Tipo de Análise:</strong> {produto?.tipoAnalise?.map((tipoAnalise) => tipoAnalise + ' , ') ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Lote:</strong> {produto?.lote ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Fabricante:</strong> {produto?.fabricante ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Endereço do Fabricante:</strong> {produto?.enderecoFabricante ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Data de Fabrico:</strong> <Date date={produto?.dataFabrico} /> </Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Data de Validade:</strong> <Date date={produto?.dataValidade} /></Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Quantidade de Amostras:</strong> {produto?.quantidadeAmostras ?? '####'}</Typography>

                    <br />
                    {solicitacaoAnalise?.resultado !== "Aprovado" &&
                        <>
                            <TextField
                                size="small"
                                label="Quatidade de amostra"
                                defaultValue={produto?.quantidadeAmostras}
                                onChange={(e) => setQuantidadeAmostras(e.target.value)}
                                variant="outlined" />
                            <Button
                                disabled={load || !quantidadeAmostras}
                                // size="small"
                                // color="warning" 
                                // variant="outlined"
                                onClick={handleQuatidadeAmostas}
                            >
                                {load ? <LoadingShort /> : "Salvar"}
                            </Button>

                            <CaptureImage />
                        </>
                    }

                    {/* LISTA DE IMAGENS DE AMOSTRAS CAPTURADAS */}
                    <List
                        sx={{ width: '100%', minWidth: '100%', bgcolor: 'background.paper' }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        <ListItemButton onClick={() => setOpenImagensCapturadas(!openImagensCapturadas)}>
                            <ListItemIcon>
                                {produto.imagens.map((foto, index) =>
                                    index < 10 &&
                                    <Avatar key={index} variant='square' id={index} src={foto} style={{ margin: 5 }} />
                                )}
                            </ListItemIcon>
                            <ListItemText primary="IMAGENS DE AMOSTRAS" />
                            {openImagensCapturadas ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>


                        <Collapse in={openImagensCapturadas} timeout="auto" unmountOnExit>

                            {produto.imagens.map((foto, index) =>
                                <div key={index} style={{ position: 'relative' }}>
                                    <img id={index} src={foto} style={{ marginBottom: 10 }} />
                                </div>
                            )}
                        </Collapse>
                    </List>
                </Card>

                <br />
                {produto?.docs?.receitaMedica &&
                    <Card>
                        <Typography variant="subtitle1" style={{ margin: 20 }}>
                            Documento anexado:
                            {/* <br /> */}
                            <a target="_blank" href={produto?.docs?.receitaMedica} >{produto?.docs?.receitaMedica ? 'Anexo' : ''} </a>
                            <br />
                        </Typography>
                        <iframe
                            id="pdfIframecontroleQualidadePruduto"
                            title={`PDF Viewer`}
                            src={[produto?.docs?.receitaMedica]}
                            width="100%"
                            height="700px"
                            style={{ border: 'none' }}
                        />
                    </Card>
                }


                <AvaliacaoAnalitica
                    produto={produto}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    solicitacaoAnalise={solicitacaoAnalise}
                    avaliacaoAnalitica={avaliacaoAnalitica}
                    setAvaliacaoAnalitica={setAvaliacaoAnalitica}
                />

                {avaliacaoAnalitica?.relatorioEmited &&
                    <DocumentosEmitidos
                        avaliacaoAnalitica={{ ...avaliacaoAnalitica, producto: produto }}
                        imageDissolucao={imageDissolucao}
                        imageTestePH={imageTestePH}
                        imageTesteVisual={imageTesteVisual}
                        imageTesteCromato={imageTesteCromato}
                    />
                }

            </>
            :
            <Loading text={'Acarregar produto..'} />
    )
}
